<template>
  <div>
    <!-- <div class="container"> -->
    <v-app-bar flat color="primary">
      <v-spacer></v-spacer>
      <img :src="`${publicPath}img/logo-white-small.png`" style="max-height: 26px;height: 100%" />
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-row>
      <v-col cols="12" style="padding: 0;position: relative">
        <canvas style="position: absolute;height: 100%;right: 0;" id="camera--sensor"></canvas>
        <video ref="video" class="camera-stream" playsinline autoplay muted></video>
      </v-col>
    </v-row>
    <v-container>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
          <v-btn block v-on="on" @click="cameraTrigger" color="primary">CAPTURE</v-btn>
        </template>
        <v-card>
          <v-container class="text-center">
            <!-- <div class="text-center"> -->
            <img style="object: fill;max-width: 100%" :src="myphoto" alt id="camera--output" />
            <!-- </div> -->
            <v-row>
              <v-col cols="6" style="color: white">
                <v-btn color="primary" style="color: white" block>ยืนยัน</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block @click="dialog = false">ยกเลิก</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import "webrtc-adapter";
export default {
  data() {
    return {
      myphoto: "",
      dialog: false,
      publicPath: process.env.BASE_URL
    };
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    cameraTrigger() {
      var cameraSensor = document.querySelector("#camera--sensor");
      var cameraView = this.$refs.video;
      // var cameraOutput = document.querySelector("#camera--output");
      cameraSensor.width = cameraView.videoWidth;
      cameraSensor.height = cameraView.videoHeight;
      cameraSensor.getContext("2d").drawImage(cameraView, 0, 0);

      this.myphoto = cameraSensor.toDataURL("image/webp");
      cameraSensor
        .getContext("2d")
        .clearRect(0, 0, cameraSensor.width, cameraSensor.height);
    },
    initVideo2() {
      var promisifiedOldGUM = function(constraints) {
        navigator.getMedia = (
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia
        ).bind(navigator);

        if (!getUserMedia) {
          //return false;
          return Promise.reject(
            new Error("getUserMedia is not implemented in this browser")
          );
        }
        return new Promise(function(resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };

      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }

      var getUserMedia = (
        navigator.mediaDevices.getUserMedia || promisifiedOldGUM
      ).bind(
        navigator
      ); /*||
     (Meteor.isCordova && cordova.plugins.iosrtc.getUserMedia)*/ // Could not make working getUserMedia in Android (cordova-plugin-iosrtc for iOS) for now. Switching to cordova-plugin-media-capture for Android and iOS.

      if (!getUserMedia) {
        this.$swal("getUserMedia is not implemented in this browser");
      }

      var constraints = {
        audio: false,
        video: true
      };

      var vm = this;
      this.video = this.$refs.video;

      getUserMedia(constraints)
        .then(stream => {
          vm.video.srcObject = stream;
          vm.video.play();
        })
        .catch(error => {
          /* eslint-disable no-console */
          console.error(error);
          /* eslint-enable no-console */
          vm.$swal({
            type: "error",
            title: "Error",
            text: error.message
          });
        });
    },
    initVideo() {
      var vm = this;
      this.video = this.$refs.video;

      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }

      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // First get ahold of the legacy getUserMedia, if present
          var getUserMedia = (
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia
          ).bind(navigator);

          // Some browsers just don't implement it - return a rejected promise with an error
          // to keep a consistent interface
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }

          // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }

      navigator.mediaDevices
        .getUserMedia({
          video: { facingMode: "user" },
          audio: false
        })
        .then(stream => {
          vm.video.srcObject = stream;
          vm.video.play();
        })
        .catch(error => {
          vm.$swal({
            type: "error",
            title: "Error",
            text: error.message
          });
        });
      // track = stream.getTracks()[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.camera-modal {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background-color: white;
  z-index: 10;
}
.camera-stream {
  width: 100%;
  // height: 100%;
}
</style>